<template>
  <div class="fill-height">
    <line-chart
      v-if="viewMode === 'chart'"
      class="fill-height"
      type="bar"
      :raw-data="volumeDistribution"
      x-value="key"
      :chart-value-keys="[{ key: 'value', label: $t('variables.UXVOL'), type: 'bar' }]"
      :yaxis="[ {labels: {
        formatter: function(value) {
          return value.toFixed(2);
        }
      } }]"
      :xaxis="{
        labels: {
          rotate: -45
        },
        categories: volumeDistribution.map(p => p.key),
        tickPlacement: 'between',
        tickAmount: 10,
        title: { text: $t('variables.UXVOL')}
      }"
      :colors="['#00E396']"
    >
      <template v-slot:header>
        <v-card-title class="pa-4">
          <v-row
            no-gutters
            align="center"
          >
            <v-col>
              <div
                class="subtitle-2 grey--text text--grey-100"
                style="word-break: normal"
              >
                {{ $t('card_title.volume_distribution') }}
              </div>
            </v-col>
            <v-col
              cols="auto"
              class="ml-3 "
            >
              <v-btn
                v-if="removable"
                icon
                style="pointer-events: auto"
                @click="$emit('remove')"
              >
                <v-icon small>
                  fal fa-times
                </v-icon>
              </v-btn>
              <visual-list-toggle
                v-else
                :value.sync="viewMode"
              />
            </v-col>
          </v-row>
        </v-card-title>
      </template>
    </line-chart>

    <v-card
      v-else-if="viewMode === 'table'"
      class="fill-height rounded-lg"
    >
      <v-card-title class="pa-4">
        <v-row
          no-gutters
          align="center"
        >
          <v-col>
            <div
              class="subtitle-2 grey--text text--grey-100"
              style="word-break: normal"
            >
              {{ $t('card_title.volume_distribution') }}
            </div>
            <v-col
              cols="auto"
              class="ml-3 "
            >
              <visual-list-toggle
                v-if="!removable"
                :value.sync="viewMode"
              />
            </v-col>
          </v-col>
        </v-row>
      </v-card-title>

      <v-data-table
        :headers="tableHeaders"
        :items="volumeDistribution"
        hide-default-footer
        disable-pagination
        :items-per-page="-1"
        fixed-header
        dense
        :height="350"
      >
        <template v-slot:item.key="{ item }">
          {{ item.key }}
        </template>
        <template v-slot:item.value="{ item }">
          {{ item.value }}
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import LineChart from '@/components/charts/LineChart.vue'
import VisualListToggle from '@/components/buttons/VisualListToggle.vue'
import { calculateDistributionFromCounts } from '@/utils/helpers'

export default {
  name: 'VolumeDistributionChart',
  components: { LineChart, VisualListToggle },
  props: {
    players: {
      type: Array,
      required: true
    },
    stats: {
      type: [Object, Array],
      default: () => ({})
    },
    removable: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    viewMode: 'chart'
  }),
  computed: {
    volumeDistribution() {
      const dist = (this.stats && this.stats.UXVOL_dist) || []

      return calculateDistributionFromCounts(dist, 1, 100, 10)
    },
    tableHeaders() {
      return [
        {
          text: this.$t('table_headers.range'),
          value: 'key',
          sortable: false,
          width: '50%'
        },
        {
          text: this.$t('variables.UXVOL'),
          value: 'value',
          sortable: true,
          align: 'center'
        }
      ]
    }
  }
}
</script>
